// extracted by mini-css-extract-plugin
module.exports = {"review":"review-module--review--3vCSw","text":"review-module--text--2f6xN","author":"review-module--author--Vt1X1","shake":"review-module--shake--25K4Q"};